import axios from "axios";

const urlPath = "sale";

export const getSalesToExcel = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/getSale/filterToExcel`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getSales = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/getSale/filter`, data.filtros, {
      params: data.params,
      signal: data.signal
    });
    return response.data;
  } catch (err) {
    if (axios.isCancel && axios.isCancel(err)) {
      return;
    }
    if (err.name === 'CanceledError') {
      return;
    }
    console.log(err.response || err);
    throw err;
  }
};
export const getSalesProperties = async (data, options = {}) => {
  try {
    const response = await axios.post(
      `${urlPath}/getSaleProperties/filter`,
      data.filtros,
      {
        params: data.params,
        ...(options.signal ? { signal: options.signal } : {})
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isCancel && axios.isCancel(error)) {
      return;
    }
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      return;
    }
    console.log(error);
    throw error;
  }
};
export const getSalesPropsIds = async (id) => {
  try {
    const response = await axios.post(`${urlPath}/getSale`, {aaff_id:id});

    return response.data;
  } catch (error) {
    console.log(error);
  }
};
export const getVisitSheetIdFromSale = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/getVisitSheetIdFromSale/${id}`);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const detailsSalesCAE = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/detailsSalesCAE/${id}`);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSale = async (id) => {
  try {
    const response = await axios.get(`${urlPath}/getSale/${id}`);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const createSale = async (data) => {

  try {
    const response = await axios.post(urlPath, data);
    
    return response.data;
  } catch (err) {
    console.log(err);
    return (err);
  }
};

export const UpdateSale = async (id,data) => {

  try {

    const response = await axios.put(`${urlPath}/${id}`, data);
    
    return response;
  } catch (err) {
    console.log(err.response);
  }
};
export const DeleteSale = async (id) => {

  try {

    const response = await axios.delete(`${urlPath}/${id}`);
    
    return response;
  } catch (err) {
    console.log(err.response);
  }
};

export const updateComentsDetailsCaes = async (data) => {
 
  try {
    const response = await axios.put(`${urlPath}/updateComentsDetailsCaes/${data.id}`, data);
    
    return response;
  } catch (err) {
    console.log(err.response);
    return err.response;
  }
};


export const noRealizada = async (id, data) => {
  try {
    const response = await axios.put(`${urlPath}/notVisit/${id}`, data);

    return response.data;
  } catch (error) {
    console.log(error);
  }
};


export const createProvsSinAcceso = async (data) => {

  try {

    const response = await axios.post(`${urlPath}/povsSinAcc`, data);
    return response.data;

  } catch (err) {
    console.log(err.response);
  }
};

export const updateProvsSinAcceso = async (id,data) => {

  try {
    
    const response = await axios.put(`${urlPath}/povsSinAcc/${id}`, data);
    return response;

  } catch (err) {
    console.log(err.response);
  }
};
export const deleteProvsSinAcceso = async (id) => {

  try {

    const response = await axios.delete(`${urlPath}/povsSinAcc/${id}`);
    
    return response;
  } catch (err) {
    console.log(err.response);
  }
};


export const getEstadosFincas = async () => {
  try {
    const response = await axios.get(`${urlPath}/states`);
    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const getQRToken = async (nif, workcenter_id = null) => {
  try {
    const response = await axios.post(`/qr/create-qr-token`, { nif, workcenter_id });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const marcarQrColocado = async (nif, workcenter_id, colocado) => {
  try {
    const response = await axios.put(`/qr/colocado`, { nif, workcenter_id, colocado });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getUrlServs = async (data) => {
  console.log(data)
  try {
    const response = await axios.post(`${urlPath}/urlServs`, data);
    return response.data;
  } catch (err) {
    console.log(err.response);
  }
};

export const getDashboardCAE = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/getSale/dashboard/cae`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getDashboardLOPD = async (data) => {
  try {
    const response = await axios.post(`${urlPath}/getSale/dashboard/lopd`, data);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getSaleCaducidad = async (data) => {
  try {
    const response = await axios.get(`${urlPath}/getSale/caducidad/${data.aaff_id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getListSalesToExport = async (data) => {
  try {
    const response = await axios.post(
      `${urlPath}/getSale/exportToExcel`,
      data.filtros,
      {
        params: data.params,
        signal: data.signal,
        responseType: 'blob', // Ahora Axios sí lo reconocerá
        headers: {
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
      }
    );
    // Verificar si la respuesta es un error JSON disfrazado de blob
    if (response.data.type === 'application/json') {
        const text = await response.data.text();
        const error = JSON.parse(text);
        throw new Error(error.error || 'Error al exportar');
    }

    return response.data;
  } catch (err) {
    if (axios.isCancel && axios.isCancel(err)) {
      return;
    }
    if (err.name === 'CanceledError') {
      return;
    }
    console.log(err.response || err);
    throw err;
  }
};